import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import Button from '../../../../components/button'

import styles from './contact.module.scss'

export default function Contact() {
  return (
    <div className={styles.root}>
      <div className={styles.outer}>
        <div className={styles.inner}>
          <h2 className={styles.heading}>
            <FormattedMessage defaultMessage="Hittar du inte det du söker?" id="press.contact.heading" />
          </h2>
          <a href="mailto:hej@dooer.com" rel="noopener noreferrer" target="_blank">
            <Button variant="link">
              <FormattedMessage defaultMessage="Maila hej@dooer.com" id="press.contact.button" />
            </Button>
          </a>
        </div>
      </div>
    </div>
  )
}
